import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGroupItemsActionResponse, IGroupItemsActionResponseData } from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";

AxiosCurlirize(axios, () => {});
export const useGroupItemsActionAPI = () => {
  const [itemsList, setItemsList] = useState<IGroupItemsActionResponseData[] | null>([]);

  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (action: string, query: string) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: IGroupItemsActionResponseData[] = await axios
        .get(`${INVENTORY_MODULE?.GROUP_ITEMS_ACTION_LIST?.baseURL}?action=${action}&search_keyword=${query}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IGroupItemsActionResponse>) => {
          if (res.data.status === true) {
            setItemsList(res.data.data);
            return res.data.data;
          } else {
            setItemsList([]);
            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          setItemsList([]);

          // captureError(e);
          return null;
        });
      return response;
    } catch (error) {
      // toast.error("Server Error: " + error.message);
      return null;
    }
  }, []);

  return { execute, itemsList };
};
